/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { animate, style, transition, trigger } from '@angular/animations';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnChanges,
  Output,
  SecurityContext,
  SimpleChanges,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AcceptEnum } from '@commons/file-picker/models/accept.enum';
import { WINDOW } from '@wizbii/angular-utilities';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-ui-file-picker-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('expand', [
      transition(':enter', [
        style({ opacity: '.4', overflow: 'hidden', width: '0' }),
        animate('400ms linear', style({ width: '*', opacity: '1' })),
      ]),
      transition(':leave', [
        style({ overflow: 'hidden' }),
        animate('400ms linear', style({ width: '0', opacity: '.4' })),
      ]),
    ]),
  ],
})
export class PreviewComponent implements OnChanges {
  @Input() id!: string;
  @Input() label!: string;
  @Input() file!: any;
  @Output() delete = new EventEmitter<void>();
  src$!: Observable<string | undefined>;
  AcceptEnum = AcceptEnum;

  confirmation!: boolean;
  mouseover!: boolean;

  constructor(
    private readonly domSanitizer: DomSanitizer,
    private readonly elementRef: ElementRef,
    @Inject(WINDOW) private readonly window: any
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['file']) {
      this.src$ = changes['file'].currentValue ? this.readFile(changes['file'].currentValue) : of('');
    }
  }

  @HostListener('document:click', ['$event'])
  doOutsideClick(event: Event): void {
    if (!this.elementRef.nativeElement.querySelector('.actions').contains(event.target)) {
      this.confirmation = false;
    }
  }

  @HostListener('mouseover')
  onMouseOver(): void {
    this.mouseover = true;
  }

  @HostListener('mouseout')
  onMouseOut(): void {
    this.mouseover = false;
  }

  openFile(file: any): void {
    this.window.open(URL.createObjectURL(file), '_blank');
  }

  private readFile(blob: any): Observable<string> {
    return new Observable<string>((observer) => {
      const reader = new FileReader();

      reader.onerror = (err) => {
        observer.error(err);
      };
      reader.onabort = (err) => {
        observer.error(err);
      };
      reader.onload = () => {
        observer.next(this.domSanitizer.sanitize(SecurityContext.URL, reader.result as string)!);
      };
      reader.onloadend = () => {
        observer.complete();
      };

      return reader.readAsDataURL(blob);
    });
  }
}
